// extracted by mini-css-extract-plugin
export default {"headerTitleColumn":"AdminProjectManagement_headerTitleColumn_IQ6SK","tableName":"AdminProjectManagement_tableName_oTAtt","spinAround":"AdminProjectManagement_spinAround_whDIb"};